import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  Link,
} from '../../../coreui';

import FadeIn from '../../../components/FadeIn';

const InvestmentPlatformSection2 = ({
  isVisible,
}) => {
  return (
    <Box
      width={[1, 1, 0.5, 0.5, 0.5]}
    >
      <ExtendedFlex
        flexDirection="column"
      >
        <ExtendedBox
          m={0}
          pb={30}
          bg="gray.1"
        >
          <ExtendedFlex
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 520, 660]}
            height={[300, 300, 400, 400, 500]}
            px={['15%', '25%', 60, 100, 120]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={isVisible ? '1' : '0'}
              >
                DUE DILIGENCE.
              </Heading>
              <Body
                type="B1"
                m={0}
                mb="4em"
                opacity={isVisible ? '1' : '0'}
              >
                Each investment on the platform has undergone the RealtyMogul due diligence process.
              </Body>
              <Link
                type="L4"
                to="/knowledge-center/due-diligence"
                opacity={isVisible ? '1' : '0'}
              >
                Learn more &gt;
              </Link>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
        <ExtendedBox
          mb={30}
        >
          <ExtendedFlex
            flexDirection="column"
            justify="center"
            maxWidth={[null, null, 520, 520, 660]}
            height={[300, 300, 400, 400, 500]}
            px={['15%', '25%', 60, 100, 120]}
          >
            <FadeIn>
              <Heading
                type="H3"
                textTransform="uppercase"
                m={0}
                mb="0.7em"
                opacity={isVisible ? '1' : '0'}
              >
                Access & Transparency.
              </Heading>
              <Body
                type="B1"
                m={0}
                mb="4em"
                opacity={isVisible ? '1' : '0'}
              >
                The platform offers Members unique investment opportunities in institutional-quality properties.
              </Body>
              <Link
                type="L4"
                to="/our-story"
                opacity={isVisible ? '1' : '0'}
              >
                Learn more &gt;
              </Link>
            </FadeIn>
          </ExtendedFlex>
        </ExtendedBox>
      </ExtendedFlex>
    </Box>
  );
};

InvestmentPlatformSection2.propTypes = {
  isVisible: PropTypes.bool,
};

export default InvestmentPlatformSection2;
